// extracted by mini-css-extract-plugin
export default {"wrap":"tasks_wrap__Pci7A","title":"tasks_title__Y5cx7","heading":"tasks_heading__OLvoS"};